import React, { useEffect } from "react";
import "./i18n";
import AppRoutes from "./routes/AppRoutes";
import { useDispatch } from "react-redux";
import {
  setBuyer,
  setAuthenticated,
  setLoading,
} from "./redux/slices/authSlice";
import Notification from "./components/Notification";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      const token = localStorage.getItem("jwtToken");
      const buyerString = localStorage.getItem("buyer");

      if (token) {
        dispatch(setAuthenticated(true));

        if (buyerString && buyerString !== "undefined") {
          dispatch(setBuyer(JSON.parse(buyerString)));
        }
      }

    } catch {
      localStorage.removeItem("jwtToken");
      localStorage.removeItem("buyer");
      dispatch(setAuthenticated(false));
    } finally {
      dispatch(setLoading(false));
    }
  }, [dispatch]);

  return (
    <div className="bg-white w-full">
      <AppRoutes />
      <Notification />
    </div>
  );
}

export default App;
